const galleryId = 35;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = ["sh_157672211.jpg","sh_507017881a.jpg","sh_1627811632.jpg","sh_1646434054.jpg","sh_572087275.jpg","sh_165493604.jpg","sh_1278844810.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Filling'));

group = ["sh_1555107824.jpg","sh_1582204078.jpg","sh_1213923457.jpg","sh_1505970428.jpg"];
group.forEach((i) => addItemToGroup(i, '2. Fissure sealing'));

group = ["sh_154168100.jpg","sh_227596483.jpg","sh_248893249.jpg","sh_371582053.jpg","sh_1597506856.jpg","sh_1301155513.jpg","sh_166386377.jpg","sh_776621521.jpg","sh_126711704.jpg","sh_126059102.jpg","sh_1735148612.jpg"];
group.forEach((i) => addItemToGroup(i, 'Before-after'));

group = ["sh_407323045.jpg","sh_1088344322.jpg"];
group.forEach((i) => addItemToGroup(i, 'deleted'));

export default items;
